<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="查询编辑">
        <span slot="label"><i class="iconfont icon-search"
            style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_search_and_edit") }}</span>
        <SplitContainer2 layout="horizontal" style="height:100%">
          <template #table1>
            <TableMain name="one table" ref="notifyManageRef" :fields="fields" :title="table_title.title1"
              :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
              :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
              :query_button_label="query_lable" @on_query="on_query" @state_change="state_change"
              :show_toolbar_button="[0, 0, 0, 0, 1]" @tool_invoke="tool_invoke" @current_changed="current_changed"
              @on_cell_button_click="on_cell_button_click">
              <!-- <template #query>
            角色名称：<el-input size="small" style="width: 120px" v-modal="roleName"></el-input>
          </template> -->
              <template #toolbar="">
                <el-button type="info" plain @click="createForm('new')" style="width: 55px"
                  class="ml-2 iconfont icon-add-new" size="mini">
                </el-button>
              </template>
            </TableMain>
          </template>
          <template #table2>
            <BaseContainer style="height:100%" class="one_table">
              <TableMain name="notifyUser" :fields="fields2" :items="items" :show_query_container="false"
                :show_toolbar="false" ref="notifyUserRef" :title="$t('table.table_user')" :isBusy="isBusy">
                <template #operation>
                  <el-button type="success" plain size="mini" class="iconfont icon-save"
                    @click="saveNotifyUser">&nbsp;{{ $t("common.save") }}
                  </el-button>
                </template>
              </TableMain>
            </BaseContainer>
          </template>
        </SplitContainer2>
      </el-tab-pane>
      <el-tab-pane label="模板管理">
        <span slot="label"><i class="iconfont icon-template"
            style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_template") }}</span>
        <NotifyTemplateManage></NotifyTemplateManage>
      </el-tab-pane>
    </el-tabs>

    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData" :size="'md'">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-form-item label="通知类型" prop="notify_type">
            <el-input v-model="dataForm.notify_type"></el-input>
          </el-form-item>
          <el-form-item label="通知名称" prop="name">
            <el-input v-model="dataForm.name"></el-input>
          </el-form-item>
          <el-form-item label="通知说明" prop="description">
            <el-input type="textarea" v-model="dataForm.description"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as NotifyManageController from "../../controllers/system/NotifyManageController"
import SplitContainer2 from "../components/container/SplitContainer2"
import NotifyTemplateManage from "./NotifyTemplateManage"

export default {
  name: "PropertyManage",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer2,
    NotifyTemplateManage
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "通知信息列表"
      },
      modal_title: "新建通知",
      fields: NotifyManageController.fields,
      fields2: NotifyManageController.fields2,
      dataForm: _.cloneDeep(NotifyManageController.dataForm),
      rules: NotifyManageController.rules,
      methods: NotifyManageController.methods,
      roleName: "",
      items: [],
      selectedItem: null,
      notifyHasData: [],
      notifyNewData: [],
      isBusy: false,
      tab_index: 0
    }
  },
  created() {
    this.GetUsers()
  },
  methods: {
    //编辑
    async on_cell_button_click(data) {
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.createForm("edit")
    },
    //保存通知--用户
    async saveNotifyUser() {
      let _this = this
      if (this.selectedItem == null) {
        this.msgToasts("请选择通知类型后再进行保存！", "warning")
        return
      }
      this.notifyNewData = _.filter(
        _this.$refs.notifyUserRef.my_data,
        d => d._selected
      )

      let _b = await this.methods.AddORDeleteNotifyUsers(
        _this.selectedItem.notify_type,
        _this.notifyHasData,
        _this.notifyNewData
      )
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
    },
    //获取权限
    async GetUsers() {
      let _dt = await this.methods.getUserData()
      this.$refs.notifyUserRef.SetData(_dt)
    },
    //#region 查询
    async on_query(set_data) {
      let _dt = await this.methods.GetNotifyTypes()
      set_data(_.orderBy(_dt, ["seq"], ["asc"]))
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "新增通知"
          this.dataForm = _.cloneDeep(NotifyManageController.dataForm)
          break
        case "edit":
          title = "编辑通知"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },
    ///新增修改
    async saveData(cb) {
      let _this = this
      await this.$refs.dataForm.validate(valid => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          ///保存数据
          if (_this.modal_title == "新增通知") {
            _this.addAndUpdate(_data, cb, true)
          } else {
            _this.addAndUpdate(_data, cb, false)
          }
        } else {
          cb(false)
          return false
        }
      })
    },
    // 新增或修改
    async addAndUpdate(_data, cb, _bool) {
      let b = await this.methods.addAndUpdate(
        {
          notify_type: _data.notify_type,
          name: _data.name,
          description: _data.description
        },
        _bool
      )
      cb(true, b.success)
      //如果未新增则在表格中新增一条数据
      //如过修改 则在表格中修改
      if (!_bool) {
        let index = _.findIndex(this.$refs.notifyManageRef.my_data, {
          notify_type: _data.notify_type
        })
        if (index > -1) {
          this.$set(
            this.$refs.notifyManageRef.my_data[index],
            "name",
            _data.name
          )
          this.$set(
            this.$refs.notifyManageRef.my_data[index],
            "description",
            _data.description
          )
        }
      } else {
        if (
          _.findIndex(this.$refs.notifyManageRef.my_data, {
            notify_type: _data.notify_type
          }) < 0
        ) {
          this.$refs.notifyManageRef.my_data.splice(0, 0, {
            notify_type: _data.notify_type,
            name: _data.name,
            description: _data.description,
            _current: false,
            _selected: false,
            _id: _data.notify_type
          })
        }
      }
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      let _b = await this.methods.UpdateNotify(data)
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      } else {
        this.msgToasts("操作失败！", "error")
      }
      cb(data.state) //回调table操作
    },
    //#endregion

    //#region 打印导出
    // tool_invoke(data, cb) {

    // },
    //#endregion

    current_changed(old, current) {
      this.$emit("current_changed", old, current)
      this.selectedItem = current
      //获取角色对应的权限
      this.isBusy = true
      let _notify_type = ""
      if (!_.isNull(current)) {
        _notify_type = current.notify_type
      }
      this.getNotifyUsers(_notify_type)
    },
    //获取角色对应的权限
    async getNotifyUsers(notify_type) {
      let _this = this
      let _dt = await this.methods.GetNotifyUsers(notify_type)
      if (!_.isNull(_dt) && _dt && _dt.length > 0) {
        this.notifyHasData = _dt
        if (this.$refs.notifyUserRef.only_selected) {
          _this.$refs.notifyUserRef.on_only_selected()
        }
        _this.$refs.notifyUserRef.UnSelectAll()
        _.each(_dt, t => {
          let _m = _.find(_this.$refs.notifyUserRef.my_data, { id: t.user_Id })
          if (_m) {
            _this.$set(_m, "_selected", true)
            _this.$refs.notifyUserRef.updateRowBackgroundColor(_m)
          }
        })
        _this.$refs.notifyUserRef.updateSelectState()
      }

      this.isBusy = false
    }
  }
}
</script>
